(() => {
  const root = document.documentElement;
  const cartRoot = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const coverageVariant = '46137618727150';
  let state = JSON.parse(document.querySelector('[data-lk-returnguard-state]').textContent);
  let pendingMutations = 0;
  let dirty = false;
  let syncing;
  let replayingCheckout = false;
  let revision = 0;

  const applyState = (next) => {
    state = next;
    root.dataset.lkReturnguardEligible = String(next.eligible);
  };

  const readState = async () => {
    const response = await nativeFetch(cartRoot + 'cart?section_id=main-cart-footer', {
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) throw new Error('Could not check ReturnGuard eligibility');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.querySelector('[data-lk-returnguard-state]');
    if (!node) throw new Error('Missing ReturnGuard eligibility');
    return JSON.parse(node.textContent);
  };

  const sync = () => {
    dirty = true;
    if (syncing) return syncing;
    root.setAttribute('data-lk-returnguard-pending', '');
    syncing = (async () => {
      while (dirty) {
        dirty = false;
        const checkedRevision = revision;
        const next = await readState();
        if (checkedRevision !== revision || pendingMutations) {
          dirty = true;
          await new Promise((resolve) => setTimeout(resolve, 80));
          continue;
        }
        applyState(next);
        if (!next.eligible && next.coverageKeys.length) {
          const updates = Object.fromEntries(next.coverageKeys.map((key) => [key, 0]));
          const response = await nativeFetch(cartRoot + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
          if (!response.ok) throw new Error('Could not remove ineligible ReturnGuard');
          const cart = await response.json();
          applyState(await readState());
          if (window.location.pathname.replace(/\/$/, '') === (cartRoot + 'cart').replace(/\/$/, '')) {
            window.location.reload();
          } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lk-returnguard', cartData: cart });
          }
        }
      }
    })().finally(() => {
      syncing = undefined;
      if (!pendingMutations) root.removeAttribute('data-lk-returnguard-pending');
    });
    return syncing;
  };

  const refresh = () => sync().catch((error) => {
    root.dataset.lkReturnguardEligible = 'false';
    console.error(error);
  });

  const coverageOnlyAdd = async (input, options) => {
    let body = options?.body;
    if (!body && input instanceof Request) body = await input.clone().text();
    try {
      if (typeof body === 'string') {
        try { body = JSON.parse(body); } catch { body = new URLSearchParams(body); }
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        return String(body.get('id')) === coverageVariant;
      }
      const items = body?.items || (body?.id ? [body] : []);
      return items.length === 1 && String(items[0].id) === coverageVariant;
    } catch {
      return false;
    }
  };

  window.fetch = async (input, options) => {
    const url = new URL(input instanceof Request ? input.url : String(input), window.location.origin);
    const isMutation = url.origin === window.location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    if (!isMutation) return nativeFetch(input, options);
    if (/\/add(\.js)?$/.test(url.pathname) && await coverageOnlyAdd(input, options)) {
      const next = await readState();
      applyState(next);
      if (!next.eligible) {
        return new Response(JSON.stringify({
          status: 422,
          message: window.cartStrings.error,
          description: window.cartStrings.error,
        }), { status: 422, headers: { 'Content-Type': 'application/json' } });
      }
    }
    pendingMutations += 1;
    revision += 1;
    root.setAttribute('data-lk-returnguard-pending', '');
    try {
      return await nativeFetch(input, options);
    } finally {
      pendingMutations -= 1;
      revision += 1;
      refresh();
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!replayingCheckout && target?.closest('#returngo-coverage') && (!state.eligible || syncing || pendingMutations)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    const checkout = target?.closest('[name="checkout"], .additional-checkout-buttons');
    if (!checkout || replayingCheckout || (!syncing && !pendingMutations && (state.eligible || !state.coverageKeys.length))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync().then(() => {
      if (!state.eligible && state.coverageKeys.length) return;
      replayingCheckout = true;
      target.click();
      replayingCheckout = false;
    }).catch(console.error);
  }, true);

  document.addEventListener('submit', (event) => {
    if (replayingCheckout || event.submitter?.name !== 'checkout') return;
    if (!syncing && !pendingMutations && (state.eligible || !state.coverageKeys.length)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    const submitter = event.submitter;
    sync().then(() => {
      if (!state.eligible && state.coverageKeys.length) return;
      replayingCheckout = true;
      form.requestSubmit(submitter);
      replayingCheckout = false;
    }).catch(console.error);
  }, true);

  if (typeof PerformanceObserver !== 'undefined') {
    new PerformanceObserver((list) => {
      if (list.getEntries().some((entry) => entry.initiatorType === 'xmlhttprequest' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(entry.name))) refresh();
    }).observe({ type: 'resource', buffered: false });
  }
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
  applyState(state);
  if (!state.eligible && state.coverageKeys.length) refresh();
})();

